import { useAppDisplayModeContext } from '@archipro-design/aria';

import ContactPageMobile from '../component/contact-tab/ContactPage.mobile';
import ContactPageDesktop from '../component/contact-tab/ContactPage.desktop';
import type { APHandle } from '~/modules/root';

const ContactPage = () => {
    const { desktop } = useAppDisplayModeContext();

    return !desktop ? <ContactPageMobile /> : <ContactPageDesktop />;
};

export const handle: APHandle = {
    disableTopNavAnimation: true,
    disableMobileUserScaling: true,
    hideContactArchiPro: true,
};

export default ContactPage;
